import { defineMessages } from '@/i18n';

export const salesAgreementMessages = defineMessages({
  addArtwork: 'platform.app.gallery.salesAgreement.addArtwork',
  addArtworkCurrencyConfiguration: 'platform.app.gallery.salesAgreement.addArtworkCurrencyConfiguration',
  inventory: 'platform.app.gallery.salesAgreement.inventory',
  createTitle: 'platform.app.gallery.salesAgreement.create.title',
  additionalTermsTitle: 'platform.app.gallery.salesAgreement.detail.additionalTerms.title',
  additionalTermsDescription: 'platform.app.gallery.salesAgreement.detail.additionalTerms.description',
  discount: 'platform.app.gallery.salesAgreement.detail.artworks.discount',
  buyerTitle: 'platform.app.gallery.salesAgreement.detail.buyer.title',
  buyerContact: 'platform.app.gallery.salesAgreement.detail.buyer.contact',
  sellerTitle: 'platform.app.gallery.salesAgreement.detail.seller.title',
  sellerContact: 'platform.app.gallery.salesAgreement.detail.seller.contact',
  costsTitle: 'platform.app.gallery.salesAgreement.detail.costs.title',
  paymentsTitle: 'platform.app.gallery.salesAgreement.detail.payments.title',
  salesDocumentsTitle: 'platform.app.gallery.salesAgreement.detail.salesDocuments.title',
  salesDocumentsDescription: 'platform.app.gallery.salesAgreement.detail.salesDocuments.description',
  draft: 'platform.app.gallery.salesAgreement.detail.draft',
  pending: 'platform.app.gallery.salesAgreement.detail.pending',
  paid: 'platform.app.gallery.salesAgreement.detail.paid',
  withdrawn: 'platform.app.gallery.salesAgreement.detail.withdrawn',
  fieldRequired: 'platform.app.gallery.salesAgreement.detail.fieldRequired',
  paymentMethodRequired: 'platform.app.gallery.salesAgreement.detail.paymentMethodRequired',
  numericField: 'platform.app.gallery.salesAgreement.detail.numericField',
  validEmail: 'platform.app.gallery.salesAgreement.detail.validEmail',
  artworksMinValue: 'platform.app.gallery.salesAgreement.detail.artworks.minValue',
  pendingCoASignatureTitle: 'platform.app.gallery.salesAgreement.status.pending.item.coa.title',
  pendingCoASignatureDescription: 'platform.app.gallery.salesAgreement.status.pending.item.coa.description',
  pendingOnboardingTitle: 'platform.app.gallery.salesAgreement.pendingOnboardingTitle',
  pendingOnboardingDescription: 'platform.app.gallery.salesAgreement.pendingOnboardingDescription',

  title: 'platform.app.gallery.salesAgreement.detail.title',
  salesAgreementTitle: 'platform.app.gallery.salesAgreement.title',
  createSalesAgreementButton: 'platform.app.gallery.salesAgreement.detail.createSalesAgreementBtn',
  createTransferButton: 'platform.app.gallery.salesAgreement.detail.createTransferBtn',
  sendSalesBtn: 'actions.send',
  saveAsDraftBtn: 'actions.saveAsDraft',
  automaticPayouts: 'platform.app.gallery.salesAgreement.detail.artworks.automaticPayouts',
  // lists
  sellSalesAgreementListTitle: 'platform.app.gallery.salesAgreements.list.sell.title',
  sellListEmptyStateTitle: 'platform.app.gallery.salesAgreements.list.sell.listEmptyStateTitle',
  sellListEmptyStateDescription: 'platform.app.gallery.salesAgreements.list.sell.listEmptyStateDescription',
  // buyers list
  buySalesAgreementListTitle: 'platform.app.gallery.salesAgreements.list.buy.title',
  buyListEmptyStateTitle: 'platform.app.gallery.salesAgreements.list.buy.listEmptyStateTitle',
  buyListEmptyStateDescription: 'platform.app.gallery.salesAgreements.list.buy.listEmptyStateDescription',

  // form
  emailLabel: 'platform.app.gallery.salesAgreement.emailLabel',
  buyerNameLabel: 'platform.app.activations.settings.name',
  messageLabel: 'platform.app.gallery.salesAgreement.messageLabel',
  messagePlaceholder: 'platform.app.gallery.salesAgreement.messagePlaceholder',
  shippingCostsLabel: 'platform.app.gallery.salesAgreement.shippingCostsLabel',
  otherCostsLabel: 'platform.app.gallery.salesAgreement.otherCostsLabel',
  salesTaxLabel: 'platform.app.gallery.salesAgreement.salesTaxLabel',
  errorsMessage: 'platform.app.gallery.salesAgreement.errorsMessage',
  totalExceedsMaximumErrorMessage: 'platform.app.gallery.salesAgreement.totalExceedsMaximumErrorMessage',
  totalIsLessThanMinimumErrorMessage: 'platform.app.gallery.salesAgreement.totalIsLessThanMinimumErrorMessage',
  testIsLessThanListPriceErrorMessage: 'platform.app.gallery.salesAgreement.testIsLessThanListPriceErrorMessage',
  artworkPriceLabel: 'platform.app.gallery.salesAgreement.artworks.priceLabel',
  unsignedCOA: 'platform.app.validation.unsignedCOA',

  //saving
  sentToBuyerNotification: 'platform.app.gallery.salesAgreement.notification.sentToBuyer',
  savedNotification: 'platform.app.gallery.salesAgreement.notification.saved',
  savedAndSentNotification: 'platform.app.gallery.salesAgreement.notification.savedAndSent',
  sendingConfirmationTitle: 'platform.app.gallery.salesAgreements.sendSalesAgreement.dialog.title',
  sendingConfirmationMessage: 'platform.app.gallery.salesAgreements.sendSalesAgreement.dialog.message',

  //deleting
  deleteConfirmationTitle: 'platform.app.gallery.salesAgreements.deleteSalesAgreement.modalTitle',
  deleteConfirmationMessage: 'platform.app.gallery.salesAgreements.deleteSalesAgreement.modalMessage',

  //withdrawing
  withdrawConfirmationTitle: 'platform.app.gallery.salesAgreements.withdrawSalesAgreement.dialog.title',
  withdrawConfirmationMessage: 'platform.app.gallery.salesAgreements.withdrawSalesAgreement.dialog.message',

  //errors
  invalidPaymentProfileMessage: 'platform.app.gallery.salesAgreements.list.sell.unverifiedError',

  // payment link
  qrCodeModalTitle: 'platform.app.gallery.salesAgreements.qrCode.modalTitle',
  qrCodeModalHelp: 'platform.app.gallery.salesAgreements.qrCode.modalHelp',
  paymentLinkCopied: 'platform.app.gallery.salesAgreements.notifications.paymentLinkCopied',

  //guest auth title
  guestAuthTitle: 'platform.app.gallery.salesAgreements.guestAuth.guestTitle',
  guestAuthSubtitle: 'platform.app.gallery.salesAgreements.guestAuth.guestSubtitle',
  guestEmailPlaceholder: 'platform.app.gallery.salesAgreements.guestAuth.guestEmailPlaceholder',

  // Selling currency
  sellingCurrencyLabel: 'platform.app.gallery.salesAgreement.sellingCurrencyLabel',
  sellingCurrencyWithName: 'platform.app.gallery.salesAgreement.sellingCurrencyWithName',
  sellingCurrencyNoteTitle: 'platform.app.gallery.salesAgreement.sellingCurrency.noteTitle',
  sellingCurrencyNoteDescription: 'platform.app.gallery.salesAgreement.sellingCurrency.noteDescription',

  /**
   * Transfers
   */
  transferCompleteLabel: 'platform.app.gallery.transfer.status.complete.label',
  transferTransferringLabel: 'platform.app.gallery.transfer.status.transferring.label',
  transferCompleteGuestDescription: 'platform.app.gallery.transfer.status.complete.guestDescription',
  transferCompleteDescription: 'platform.app.gallery.transfer.status.complete.description',
  transferTransferringDescription: 'platform.app.gallery.transfer.status.transferring.description',
  transferAccept: 'platform.app.gallery.salesAgreement.transfers.acceptTransfer',
  transfersAcceptTransferQuestion: 'platform.app.gallery.salesAgreement.transfers.acceptTransferQuestion',
  transfersCreateTitle: 'platform.app.gallery.salesAgreement.transfers.create.title',
  transfersCreateDescription: 'platform.app.gallery.salesAgreement.transfers.create.description',
  transferRecipientTitle: 'platform.app.gallery.salesAgreement.transfers.detail.recipient.title',
  transferBuyerName: 'platform.app.gallery.salesAgreement.transfers.detail.recipient.buyerName',
  transferTransferNote: 'platform.app.gallery.salesAgreement.transfers.detail.transferNote',
  transferTransferNoteDescription: 'platform.app.gallery.salesAgreement.transfers.detail.transferNoteDescription',
  withdrawTransferConfirmationTitle: 'platform.app.gallery.transfer.withdrawTransfer.dialog.title',
  withdrawTransferConfirmationMessage: 'platform.app.gallery.transfer.withdrawTransfer.dialog.message',
  transferQrCodeModalTitle: 'platform.app.gallery.transfer.qrCode.modalTitle',
  transferQrCodeModalHelp: 'platform.app.gallery.transfer.qrCode.modalHelp',
  transferConfirmationLinkCopied: 'platform.app.gallery.transfer.notifications.confirmationLinkCopied',
  transferSellListEmptyStateTitle: 'platform.app.gallery.transfer.list.sell.listEmptyStateTitle',
  transferSellListEmptyStateDescription: 'platform.app.gallery.transfer.list.sell.listEmptyStateDescription',
  transferBuyListEmptyStateTitle: 'platform.app.gallery.transfer.list.buy.listEmptyStateTitle',
  transferBuyListEmptyStateDescription: 'platform.app.gallery.transfer.list.buy.listEmptyStateDescription',
  transferGuestAuthSubtitle: 'platform.app.gallery.transfer.guestAuth.guestSubtitle',
  transferSentToBuyerNotification: 'platform.app.gallery.transfer.notification.sentToBuyer',
  transferSavedNotification: 'platform.app.gallery.transfer.notification.saved',
  transferSavedAndSentNotification: 'platform.app.gallery.transfer.notification.savedAndSent',
  transferSendingConfirmationTitle: 'platform.app.gallery.transfer.sendSalesAgreement.dialog.title',
  transferSendingConfirmationMessage: 'platform.app.gallery.transfer.sendSalesAgreement.dialog.message',
});
